import { Suspense } from 'react'
import { PCFShadowMap } from 'three'

import { Canvas, Helpers } from '@components/helpers'
import {
  AboutMe,
  Animating,
  Cameras as CamerasSlide,
  Character,
  CharacterAnimation,
  Controls,
  End,
  Examples,
  FirstScene,
  Geometries,
  Goal,
  Grid,
  GridAnimation,
  Lights,
  Lights2,
  Overview,
  Resizing,
  Shadows,
  Title,
  WebGL,
} from '@components/slides'

import { Cameras } from './Cameras'
import { Environment } from './Environment'
import { Loader } from './Loader'
import { Preloader } from './Preloader'
import { Presentation } from './Presentation'

export function Experience() {
  return (
    <Canvas shadows={{ type: PCFShadowMap }}>
      <Environment />
      <Cameras />
      <Helpers />

      <Suspense fallback={<Loader />}>
        <Preloader>
          <Presentation backgroundColor="orange">
            <Title />
            <Goal />
            <Overview />
            <AboutMe />
            <WebGL />
            <Examples />
            <FirstScene />
            <Resizing />
            <Animating />
            <CamerasSlide />
            <Controls />
            <Geometries />
            <Character />
            <Grid />
            <Lights />
            <Lights2 />
            <Shadows />
            <CharacterAnimation />
            <GridAnimation />
            <End />
          </Presentation>
        </Preloader>
      </Suspense>
    </Canvas>
  )
}
